import {BaseEntity} from '../../common/base-entity';
import {CirfConfigTopic} from './cirf-config-topic';

export class CirfConfig extends BaseEntity {
    id: number;
    matterType: string;
    cirfTopics: CirfConfigTopic[];

    constructor(config?: CirfConfig) {
        super(config);
        if (config) {
            if (config.cirfTopics) {
                this.cirfTopics = config.cirfTopics.map(topic => new CirfConfigTopic(topic));
            }
        } else {
            this.cirfTopics = [];
        }
    }
}
